<template>
    <div
        class="MessageContent"
        @mousedown="event_mouse_down"
        @mouseleave="event_mouse_leave"
        @mouseup="event_mouse_up"
        @mousemove="event_mouse_move"
        ref="scroll"
    >
        <v-spacer></v-spacer>
        <div class="carousel-item" v-for="(carousel, i) in carouselList" :key="i">
            <div
                class="carousel-image"
                :style="'background-image:url(' + carousel.image_url+')'"
                @click="showLightBox(i)"
            ></div>
            <div style="padding: 8px">
                <div class="message-title" :title="carousel.title">
                    {{ carousel.title }}
                </div>
                <div class="message-sub-title" :title="carousel.subtitle">
                    {{ carousel.subtitle ? carousel.subtitle : '...' }}
                </div>
                <button class="message-btn" v-for="(b, ib) in carousel.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentCarousel",
    extends: MessageContent,
    data () {
        return {
            carouselList: []
        }
    },
    mounted () {
        if (this.content.carousel_cards) {
            this.carouselList = this.content.carousel_cards
        }
    },
    methods: {
        showLightBox (index) {
            let items = this.carouselList.map(item => ({
                title: item.title,
                description: item.subtitle,
                src: item.image_url,
            }))
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {
                data: items,
                index
            });
        },
        event_mouse_down (e) {
            this.isMouseDown = true;
            let el = this.$refs.scroll
            this.startX = e.pageX - el.offsetLeft;
            this.scrollLeft = el.scrollLeft;
        },
        event_mouse_leave () {
            this.isMouseDown = false;
        },

        event_mouse_up () {
            this.isMouseDown = false;
        },
        event_mouse_move (e) {
            if (!this.isMouseDown) return
            e.preventDefault();
            let el = this.$refs.scroll
            const x = e.pageX - el.offsetLeft;
            const walk = (x - this.startX) * 3
            el.scrollLeft = this.scrollLeft - walk
        }
    }
}
</script>
<style lang="scss" scoped src="../../style/message-box.scss"></style>
<style lang="scss" scoped>
.carousel-item {
    flex: 0 0 200px;
    margin: 0 10px;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;

    &:last-child {
        margin-right: 0;
    }
}

.carousel-image {
    background-size: cover;
    height: 150px;
}
</style>
